<mat-expansion-panel>
	<mat-expansion-panel-header>
		<mat-panel-title fxLayoutAlign="space-between">
			<span class="panel-title">
				{{ diagnostics.ClassName }}
			</span>
			<button mat-button class="outline-btn btn-blue" (click)="$event.stopPropagation(); onAddDiagnosticClick()">
				Add an Existing Diagnostic
			</button>
		</mat-panel-title>
	</mat-expansion-panel-header>

	<div class="panel-body">
		<div *ngIf="!diagnosticsLoading && !diagnostics.Diagnostics.length" class="no-diagnostic">
			There is no Diagnostic selected for this class. Please
			<span class="select-text" (click)="onAddDiagnosticClick()">add</span>
			a diagnostic
		</div>

		<div *ngIf="diagnostics.Diagnostics.length">
			<div *ngFor="let diagnostic of diagnostics.Diagnostics" class="diagnostic-card" fxLayout="row"
				fxLayoutAlign="space-between center" (click)="onDiagnosticClick(diagnostic)">
				<div fxFlex="24" class="diagnostic-name">
					{{ diagnostic.LessonName }}
				</div>
				<div fxFlex="27" class="diagnostic-progress border-r">
					Diagnostics in Progress
					<div class="diagnostic-value">
						{{ diagnostic.DiagInProgress }}
					</div>
				</div>
				<div fxFlex="27" class="awaiting-assignment border-r">
					Awaiting ILP Assignment
					<div class="diagnostic-value">
						{{ diagnostic.StudentsawaitingILP.length }}
					</div>
				</div>
				<div fxFlex="22" class="lesson-progress">
					Lesson Progress
					<div class="diagnostic-value">
						{{ diagnostic.LessonsComplete }} / {{ diagnostic.LessonsTotal }}
					</div>
				</div>
				<div class="needs-attention">
					{{ diagnostic.StudentsNeedAttentionCount }}
				</div>
			</div>
    </div>

    <div *ngIf="diagnosticsLoading" class="spinner-wrapper">
      <mat-spinner [diameter]="50" mode="indeterminate"></mat-spinner>
    </div>
	</div>
</mat-expansion-panel>
